import { render } from "./WomensClinicPage.vue?vue&type=template&id=4b1d5951&scoped=true"
import script from "./WomensClinicPage.vue?vue&type=script&lang=js"
export * from "./WomensClinicPage.vue?vue&type=script&lang=js"

import "./WomensClinicPage.vue?vue&type=style&index=0&id=4b1d5951&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1d5951"]])

export default __exports__